export default {"src":"/_next/static/media/ruby.f8a4bb76.svg","height":255,"width":256,"blurWidth":0,"blurHeight":0};